module.exports = __webpack_public_path__ + "img/impuls-1-300x101.85db0300.png";